module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Cena (zł)",
      "error": _vm.errors.price
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.price),
      callback: function($$v) {
        _vm.$set(_vm.form, "price", $$v)
      },
      expression: "form.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ilość dostępnych leżaków",
      "error": _vm.errors.quantity
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.quantity),
      callback: function($$v) {
        _vm.$set(_vm.form, "quantity", $$v)
      },
      expression: "form.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Minimalna ilość przy rezerwacji",
      "error": _vm.errors.min_to_book
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.min_to_book),
      callback: function($$v) {
        _vm.$set(_vm.form, "min_to_book", $$v)
      },
      expression: "form.min_to_book"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Maksymalna ilość przy rezerwacji",
      "error": _vm.errors.max_to_book
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.max_to_book),
      callback: function($$v) {
        _vm.$set(_vm.form, "max_to_book", $$v)
      },
      expression: "form.max_to_book"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Typ leżaka",
      "error": _vm.errors.type
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Typ leżaka",
      "clearable": ""
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, _vm._l((_vm.loungerTypes), function(loungerType) {
    return _c('el-option', {
      key: loungerType.value,
      attrs: {
        "label": loungerType.label,
        "value": loungerType.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Data",
      "error": _vm.errors.date
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy/MM/dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Data"
    },
    model: {
      value: (_vm.form.date),
      callback: function($$v) {
        _vm.$set(_vm.form, "date", $$v)
      },
      expression: "form.date"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('manage')) + "\n          ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('submit')) + "\n            ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d962798"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Loungers/LoungerForm.vue
// module id = 728
// module chunks = 0